import request from "@/utils/request";

// 列表(主数据列表)
export function loadIssuePolicyInfoListDataApi(data) {
    return request({
      url: "web/issuePolicyInfo/listData",
      method: "post",
      data
    });
  }
  // 导出
  export function loadIssuePolicyInfoExportDataApi(data) {
    return request({
      url: "web/issuePolicyInfo/exportData",
      method: "post",
      data
    });
  }
  
  // 保存
  export function saveOrUpdateIssuePolicyInfoApi(data) {
    return request({
      url: "web/issuePolicyInfo/saveOrUpdate",
      method: "post",
      data
    });
  }
  
  // 查看
  export function initIssuePolicyInfoApi(data) {
    return request({
      url: "web/issuePolicyInfo/init",
      method: "post",
      data
    });
  }
  
  // 根据条件查看最近明细
  export function findIssuePolicyInfoDetailByCityIdApi(data) {
    return request({
      url: "web/issuePolicyInfo/findInfoDetailByCityId",
      method: "post",
      data
    });
  }
// 明细列表
export function loadIssuePolicyInfoDetailListDataApi(data) {
  return request({
    url: "web/issuePolicyInfoDetail/listData",
    method: "post",
    data
  });
}
// 明细导出
export function loadIssuePolicyInfoDetailExportDataApi(data) {
  return request({
    url: "web/issuePolicyInfoDetail/exportData",
    method: "post",
    data
  });
}